// ⚠️ HER DEPLOY ÖNCESİ BU SAYIYI ARTTIRIN
// Format: vMAJOR.MINOR.PATCH
//
// MAJOR  → Büyük sürüm (örn. yeni modül, breaking change)
// MINOR  → Yeni özellik eklendi (geriye uyumlu)
// PATCH  → Bug fix / küçük iyileştirme / içerik güncelleme
//
// Bu numara admin panelin alt köşesinde ve login ekranında görünür.
// livanespor.org'da bu numara değişmişse → deploy başarılı demektir.

export const APP_VERSION = "1.12.0";
export const BUILD_DATE = "2026-05-04";
